import { createModalStore } from './createModalStore';

export const secretsModalStore = createModalStore('secrets');
